import FullInfoField from 'components/FullInfoField/FullInfoField';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from 'modules/CustomersAndRestaurants/Customers/CustomerFullInfo/customerFullInfoState/customerFullInfoContext';
import React, { useContext } from 'react';
import moment from 'moment';

const LastSyncField: React.FC = () => {
	const { latestSoftwareUpdateData } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	const inputValue = latestSoftwareUpdateData?.lastMenuSyncDate
		? `${moment(latestSoftwareUpdateData.lastMenuSyncDate).format('MM/DD/YYYY h:mm:ss A')}`
		: undefined;

	return <FullInfoField label="lastMenuSyncLabel" value={inputValue} />;
};

export default LastSyncField;
